import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { stats } from "../../data/content";
export function StatsSection() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-287" data-mp="3028gw2vor6gv">
      <div className="mx-auto max-w-5xl" data-id="element-288" data-mp="303tbfsi02peq">
        <SectionHeading kicker="A practical clinical reference for dental professionals" title="Turn Complex Whitening Decisions Into a Clearer Clinical Workflow." data-id="element-289" data-mp="350tfjxvahi37" />
        <dl className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-290" data-mp="1k37zek26wze">
          {stats.map(s => <div key={s.label} className="flex flex-col items-center rounded-2xl bg-mist px-3 py-6 text-center" data-id="element-291" data-mp="3j1e2n688m02i">
              <dt className="order-2 mt-1 text-[13px] font-semibold leading-snug text-muted" data-id="element-292" data-mp="3nz5vc2gphq7r">{s.label}</dt>
              <dd className="order-1 font-display text-[44px] font-black leading-none text-brand-dark" data-id="element-293" data-mp="fj2tweg6sxrv">{s.value}</dd>
            </div>)}
        </dl>
        <p className="mx-auto mt-8 max-w-2xl text-center text-[17px] leading-relaxed text-muted" data-id="element-294" data-mp="14h5c243kf0at">
          No unnecessary complexity. Just organized clinical knowledge, visual explanations, and practical resources you can consult when
          evaluating whitening treatments.
        </p>
        <SectionCta label="I want my clinical workflow" note="Instant digital access · $27 one-time payment" data-id="element-295" data-mp="1e8rqe9b79fhs" />
      </div>
    </section>;
}